import { Text } from '@buffer-mono/popcorn'

import type { ValidHeaders } from './validators'

import styles from './CsvExampleTable.module.css'

interface CsvExampleTableProps {
  headers: ValidHeaders[]
}

export const CsvExampleTable = ({
  headers,
}: CsvExampleTableProps): JSX.Element => {
  const columnCount = headers.length
  return (
    <div className={styles.csvExampleTable}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th></th>
            {Array.from({ length: columnCount }).map((_, index) => (
              <th key={index}>
                <Text size="sm" color="subtle">
                  {String.fromCharCode(65 + index)}
                </Text>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <Text size="sm" color="subtle">
                1
              </Text>
            </td>
            {headers.map((header) => (
              <td key={header}>
                <Text size="sm" color="subtle">
                  {header}
                </Text>
              </td>
            ))}
          </tr>
          <tr>
            <td>
              <Text size="sm" color="subtle">
                2
              </Text>
            </td>
            {Array.from({ length: columnCount }).map((_, index) => (
              <td key={index}></td>
            ))}
          </tr>
          <tr>
            <td>
              <Text size="sm" color="subtle">
                3
              </Text>
            </td>
            {Array.from({ length: columnCount }).map((_, index) => (
              <td key={index}></td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  )
}
